import { ValidationResult } from '../types'

export const VALID_RESULT: ValidationResult = { isValid: true }
